module.exports = __webpack_public_path__ + "img/petstairs05.4d28d1d7.jpg";